import React, { useEffect } from "react";
import { DatePicker, Modal, Select, TimePicker } from "antd";
import { Button, Form, Input } from "antd";
import { isAfter, setHours, setMinutes } from "date-fns";
import { useTranslation } from "react-i18next";

const { Option } = Select;

type Props = {
  isOpen: boolean;
  onCloseModal: () => void;
  onAddOvertime: (costs: any) => void;
  userDetails: any;
};

const UserOvertimeModal: React.FC<Props> = ({
  isOpen,
  onCloseModal,
  onAddOvertime,
  userDetails,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm(); // Create a form instance using Form.useForm()

  useEffect(() => {
    // Set form initial values when activeNotes changes

    // Reset form fields if activeNotes is null or undefined
    form.resetFields();
  }, [form]);
  const handleOk = () => {
    onCloseModal();
  };
  const handleCancel = () => {
    onCloseModal();
  };

  const onFinish = (values: any) => {
    const date = values.selectedDate?.toDate(); // Antd DatePicker koristi dayjs ako nije transformisan
    const fromTime = values.from?.toDate();
    const toTime = values.to?.toDate();

    if (!date || !fromTime || !toTime) return;

    const from = setMinutes(
      setHours(new Date(date), fromTime.getHours()),
      fromTime.getMinutes()
    );
    const to = setMinutes(
      setHours(new Date(date), toTime.getHours()),
      toTime.getMinutes()
    );

    if (!isAfter(to, from)) {
      form.setFields([
        {
          name: "to",
          errors: [t("End time must be after start time")],
        },
      ]);
      return;
    }

    const payload = {
      ...values,
      from,
      to,
    };

    onAddOvertime(payload);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error("Failed:", errorInfo);
  };

  return (
    <Modal
      title={t("Add Overtime")}
      open={isOpen}
      className="standardHeader"
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[]}
    >
      <Form
        name="basic"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        //   initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item label={t("Description")} name="description">
          <Input />
        </Form.Item>
        {/* <Form.Item
          label={t("Leave Type")}
          name="clientLeaveType"
          rules={[{ required: true, message: t("Please enter leave type") }]}
        >
          <Input />
        </Form.Item> */}
        <Form.Item
          name="clientOvertimeType"
          label={t("User Overtime")}
          rules={[{ required: true, message: "Please select overtime type!" }]}
        >
          <Select
            placeholder={t("Select overtime type")}
            // onChange={onGenderChange}
            showSearch // Add this prop to enable search
          >
            {userDetails?.user?.overtimeTypes?.map(
              (item: any, index: number) => {
                return (
                  <Option value={item?._id} key={index}>
                    {item?.overtimeName}
                  </Option>
                );
              }
            )}
          </Select>
        </Form.Item>
        <Form.Item
          name="selectedDate"
          label={t("Date")}
          rules={[{ required: true, message: t("Please select a date") }]}
        >
          <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" placeholder={t("Select date")} />
        </Form.Item>

        <Form.Item
          name="from"
          label={t("Start Time")}
          rules={[{ required: true, message: t("Please select start time") }]}
        >
          <TimePicker format="HH:mm" style={{ width: "100%" }} placeholder={t("Select time")} />
        </Form.Item>

        <Form.Item
          name="to"
          label={t("End Time")}
          dependencies={["from"]}
          rules={[
            { required: true, message: t("Please select end time") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const from = getFieldValue("from");
                if (!value || !from) return Promise.resolve();

                const fromTime = from?.toDate();
                const toTime = value?.toDate();

                const fromTotal =
                  fromTime.getHours() * 60 + fromTime.getMinutes();
                const toTotal = toTime.getHours() * 60 + toTime.getMinutes();

                return toTotal > fromTotal
                  ? Promise.resolve()
                  : Promise.reject(
                    new Error(t("End time must be after start time"))
                  );
              },
            }),
          ]}
        >
          <TimePicker format="HH:mm" style={{ width: "100%" }} placeholder={t("Select time")} />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit">
            {t("Save")}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserOvertimeModal;
